import { put, select, takeLatest, take } from 'redux-saga/effects';
import { setCurrentCostQueryStart } from '@amzn/seller-provided-costs-component';
import {
  PROGRAM_METADATA_QUERY_FAILED,
  PROGRAM_METADATA_QUERY_SUCCESS,
  ProgramMetadataQueryStartAction,
  setProgramMetadataQueryStart,
} from '../actions/ProgramMetadataAction';
import {
  DEFINED_PRODUCT_UPDATE,
  getUpdateQueryProductSuccessAction,
  QueryProductUpdateAction,
  SELECTED_PRODUCT_UPDATE,
} from 'src/actions/QueryProductUpdateAction';
import { setProgramFeesQueryStart } from 'src/actions/ProgramFeesQueryAction';
import {
  defaultIndexedPrograms,
  haulIndexedPrograms,
  getDefaultProgramParam,
  isLoginMode,
  isWidget,
  PROGRAM_NAME_OF_HAUL,
} from 'src/config/Config';
import { setNewProgramFeesQueryStart } from 'src/actions/NewProgramFeesQueryAction';
import { UpdateQueryProductResponse } from 'src/model/QueryProduct';
import { setRecommendationQueryStart } from 'src/actions/RecommendationQueryAction';
import GetUserPreferenceResponse from 'src/model/UserPreference';
import RequestStatus from 'src/model/RequestStatus';
import ApplicationState from 'src/model/ApplicationState';
import { setUserInputQueryStart } from 'src/actions/UserInputAction';
import GetProgramMetadataResponse, {
  ProgramMetadataResponse,
} from 'src/model/ProgramMetadata';

export const getUserPreference = (state: ApplicationState) =>
  state.userPreferenceRes;
export const getProgramMetaData = (state: ApplicationState) =>
  state.programMetadataRes;
export function* updateQueryProductData(action: QueryProductUpdateAction) {
  try {
    const userPreferenceResponse: GetUserPreferenceResponse = yield select(
      getUserPreference,
    );
    const recommendationEnabled: boolean =
      userPreferenceResponse &&
      userPreferenceResponse.requestStatus === RequestStatus.SUCCESS &&
      userPreferenceResponse.data.recommendationEnabled;
    const autoSaveInputsEnabled: boolean =
      userPreferenceResponse &&
      userPreferenceResponse.requestStatus === RequestStatus.SUCCESS &&
      userPreferenceResponse.data.autoSaveInputs;
    const response: UpdateQueryProductResponse = {
      countryCode: action.countryCode,
      queryProduct: action.queryProduct,
    };
    yield put(getUpdateQueryProductSuccessAction(response));

    // Use the response of getprograms API to determine defaultPrograms.
    yield put(
      setProgramMetadataQueryStart(action.countryCode, action.queryProduct),
    );
    const programMetadataAction: ProgramMetadataQueryStartAction = yield take([
      PROGRAM_METADATA_QUERY_SUCCESS,
      PROGRAM_METADATA_QUERY_FAILED,
    ]);

    let defaultPrograms = defaultIndexedPrograms;
    if (programMetadataAction.type === PROGRAM_METADATA_QUERY_SUCCESS) {
      const programMetadataResponse: GetProgramMetadataResponse = yield select(
        getProgramMetaData,
      );
      const metaData: ProgramMetadataResponse = programMetadataResponse.data;
      if (metaData && Array.isArray(metaData.programInfoList)) {
        const hasHaulProgram = metaData.programInfoList.some(
          (program) => program.name === PROGRAM_NAME_OF_HAUL,
        );
        if (hasHaulProgram) {
          defaultPrograms = haulIndexedPrograms;
        }
      }
    }

    if (!action.queryProduct.isNewDefined) {
      if (isLoginMode() && !isWidget()) {
        if (recommendationEnabled) {
          yield put(
            setRecommendationQueryStart(
              action.countryCode,
              action.queryProduct.asin,
            ),
          );
        }
      }
      if (!isWidget()) {
        // widget has called before get product info
        if (autoSaveInputsEnabled && !!action.queryProduct.merchantSku) {
          yield put(
            setUserInputQueryStart(
              action.queryProduct.asin || '',
              action.queryProduct.merchantSku || 'null',
              action.countryCode,
            ),
          );
        }
        if (isLoginMode()) {
          yield put(
            setCurrentCostQueryStart(
              action.queryProduct.merchantSku || action.queryProduct.asin || '',
              action.countryCode,
            ),
          );
        }
        yield put(
          setProgramFeesQueryStart(
            action.countryCode,
            action.queryProduct,
            defaultPrograms,
            getDefaultProgramParam(defaultPrograms, action.countryCode),
          ),
        );
      } else {
        yield put(
          setCurrentCostQueryStart(
            action.queryProduct.merchantSku || action.queryProduct.asin || '',
            action.countryCode,
          ),
        );
      }
    } else {
      yield put(
        setNewProgramFeesQueryStart(
          action.countryCode,
          action.queryProduct,
          defaultPrograms,
          getDefaultProgramParam(defaultPrograms, action.countryCode),
        ),
      );
    }
  } catch (error) {
    console.error('UpdateQueryProductData error' + error);
  }
}

export default function* queryProductData() {
  yield takeLatest(
    [DEFINED_PRODUCT_UPDATE, SELECTED_PRODUCT_UPDATE],
    updateQueryProductData,
  );
}
